import { createAction } from '@reduxjs/toolkit';

export const jsSnippetSectionActions = {
  notification: createAction<{ customMessage: string }>('JsSnippetSection/Notification'),
};
